module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}\r\n\r\n.box1{\r\n    border: black;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    padding:20px;\r\n    background: #fff;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-details/landdetails-form/landdetails-form.component.css
// module id = ./src/app/landprocurement/land-details/landdetails-form/landdetails-form.component.css
// module chunks = main